import { PageHeader, Tag , Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { TableItemDinamico, dineroDisabledMask, SegmentedItem, ButtonItem } from "../../../Components/Items";
import moment from "moment";
import 'moment/locale/es'
import { MailOutlined, EditOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import ModalMandarCorreoFacturas from "../FacturasCajaChica/ModalMandarCorreoFacturas/ModalMandarCorreoFacturas";
import ModalEditarDatosFactura from "../../../Components/ModalEditarDatosFactura";

moment.locale('es')

// El permiso de editar depende del tipo de factura, que en este listado es un campo calculado
// por el backend (facturas/selectFacturas).
const PERMISO_EDITAR_POR_TIPO = {
  "Caja Chica": "permisoEditarFacturasCajaChica",
  "Con Orden De Compra": "permisoEditarFacturasOrdenDeCompra",
  "Sin Orden De Compra": "permisoEditarFacturasSinOrdenDeCompra",
};

class Facturas extends Component {
  tableRef = null;
  state = {
    todasFacturas: [],
    totalRecords: 0, 
    loading: false,
    valor: 1,
    tipoFactura : null,
    modalCorreo: false,
    modalCorreoId: null,
    modalEditarDatos: false,
    modalEditarDatosId: null,
  }
  

  consultarFacturas (params = {}){
    this.setState({ loading: true });
    const body = {
      empresaId: this.props.empresaId,
      ...params,
    };

    axios
      .post(
        "facturas/selectFacturas", 
        body,
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });

        let data = [];
        let total = 0;

        if (res.data.success === 2) {
          data = res.data.data;
          total = res.data.totalRecords;
        } else if (Array.isArray(res.data)) {
          data = res.data;
          total = res.data.length;
        } else if (res.data.status === 404) {
          data = [];
          total = 0;
        }

        this.setState({
          totalRecords: total,
          todasFacturas: data.map((value) => {
            return {
              ...value,
              proveedorNombre: value.proveedorNombre || (value.proveedor ? value.proveedor.razonSocial : ""),
              accion: {
                _id: value._id,
                estado: value.estado,
                xml: value.xml,
                estadoPago: value.estadoPago,
              },
            };
          }),
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ loading: false, todasFacturas: [], totalRecords: 0 });
      });
  }

  
  descargarXml(value) {
    axios
      .post(
        "facturas/descargarXml",
        { facturaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        var xmltext = res.data.string;

        var filename = "file.xml";
        var pom = document.createElement("a");
        var bb = new Blob([xmltext], { type: "text/plain" });

        pom.setAttribute("href", window.URL.createObjectURL(bb));
        pom.setAttribute("download", filename);

        pom.dataset.downloadurl = [
          "text/plain",
          pom.download,
          pom.href,
        ].join(":");
        pom.draggable = true;
        pom.classList.add("dragout");

        pom.click();
      });
  }

  abrirMandarCorreoFactura(id, tipoFactura) {
    this.setState({
      modalCorreo: true,
      modalCorreoId: id,
      tipoFactura : tipoFactura,
    });
  }

  cerrarMandarCorreoFactura() {
    this.setState({
      modalCorreo: false,
      modalCorreoId: null,
      tipoFactura : null,
    });
  }

  abrirEditarDatosFactura(id) {
    this.setState({ modalEditarDatos: true, modalEditarDatosId: id });
  }

  cerrarEditarDatosFactura(recargar = false) {
    this.setState({ modalEditarDatos: false, modalEditarDatosId: null });
    if (recargar && this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
  }
  render() {
    const { todasFacturas, totalRecords, loading } = this.state;
    const columns = [
      {
        title: "Núm",
        dataIndex: "numeroFactura",
        key: "numeroFactura",
        sorter: (a, b) => {
          if (a.codigoFactura < b.codigoFactura) {
            return -1;
          }
          if (a.codigoFactura > b.codigoFactura) {
            return 1;
          }
          return 0;
        },
        buscar: 'numeroFactura',
        width: '8%',
        ellipsis: true,
      },
      {
        title: "Codigo",
        dataIndex: "codigoFactura",
        key: "codigoFactura",
        // sorter: (a, b) => {
        //   if (a.codigoFactura < b.codigoFactura) {
        //     return -1;
        //   }
        //   if (a.codigoFactura > b.codigoFactura) {
        //     return 1;
        //   }
        //   return 0;
        // },
        render: (value) => value,
        buscar: 'codigoFactura',
        width: '8%',
        ellipsis: true,
      },
      {
        title: "Orden de Compra",
        dataIndex: "numeroOc",
        key: "numeroOc",
        // sorter: (a, b) => {
        //   if (a.codigoFactura < b.codigoFactura) {
        //     return -1;
        //   }
        //   if (a.codigoFactura > b.codigoFactura) {
        //     return 1;
        //   }
        //   return 0;
        // },
        render: (value) => value,
        buscar: 'numeroOc',
        width: '8%',
        ellipsis: true,
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        sorter: (a, b) => {
          if (a.proyecto.nombre < b.proyecto.nombre) {
            return -1;
          }
          if (a.proyecto.nombre > b.proyecto.nombre) {
            return 1;
          }
          return 0;
        },
        render: (value) => value.nombre,
        width: '8%',
        ellipsis: true,
      },
      {
        title: "Proveedor",
        dataIndex: "proveedorNombre",
        key: "proveedorNombre",
        buscar: "proveedorNombre",
        width: '16%',
        ellipsis: true,
      },
      {
        title: "Fecha",
        dataIndex: "fechaFactura",
        key: "fechaFactura",
        defaultSortOrder: 'descend',
        sorter: (a, b) => {
          if (moment(a.fechaFactura) < moment(b.fechaFactura)) {
            return -1;
          }
          if (moment(a.fechaFactura) > moment(b.fechaFactura)) {
            return 1;
          }
          return 0;
        },
        render: (value) => moment(value).locale('es').format('L'),
        width: '8%',
        ellipsis: true,
        align: 'center',
      },
      {
        title: "Recepción",
        dataIndex: "fechaRecepcion",
        key: "fechaRecepcion",
        defaultSortOrder: 'descend',
        render: (value, record) => moment(value || record.createdAt).locale('es').format('L'),
        width: '8%',
        ellipsis: true,
        align: 'center',
      },
      {
        title: 'Subtotal / Total',
        dataIndex: 'subtotal',
        key: 'subtotal',
        sorter: (a, b) => {
          if (a.subtotal < b.subtotal) {
            return -1;
          }
          if (a.subtotal > b.subtotal) {
            return 1;
          }
          return 0;
        },
        render: (_, record) => (
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: "12px", color: "#666", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.subtotal)}</span>
               {record.moneda?.abreviacion && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda.abreviacion}</span>} 

            </div>
            <div style={{ fontSize: "12px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
              <span>{dineroDisabledMask(record.totalPagar)}</span>
              {record.moneda?.abreviacion && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda.abreviacion}</span>}
            </div>
          </div>
        ),
        buscar: 'subtotal',
        width: '12%',
        ellipsis: true,
        align: "right",
      },
      {
        title: 'Total',
        dataIndex: 'totalPagar',
        key: 'totalPagar',
        sorter: (a, b) => {
          if (a.totalPagar < b.totalPagar) {
            return -1;
          }
          if (a.totalPagar > b.totalPagar) {
            return 1;
          }
          return 0;
        },
        buscar: 'totalPagar',
        responsive: [],
        width: 0,
      },
      {
        title: 'Estado',
        dataIndex: 'estado',
        key: 'estado',
        render: (value, record, index) => {
          const tags = []; 
          if (value === 0) {
            tags.push(<Tag key={index.toString()} color='red' className="square-tag2">Cancelada</Tag>)
          }
          if (value === 1) {
            tags.push(<Tag key={index.toString()} color='blue' className="square-tag2">Sin recibir</Tag>)
          }
          if (value === 2) {
            tags.push(<Tag key={index.toString()} color='orange' className="square-tag2">Recibido parcialmente</Tag>)
          }
          if (value === 3) {
            tags.push(<Tag key={index.toString()} color='green' className="square-tag2">Recibido</Tag>)
          }

          if (record.prorrateoDesCostos) {
            tags.push(<Tag key={`prorrateo-${record._id}`} color='geekblue' className="square-tag2">Prorrateo</Tag>)
          }

          if (record.cargaHistorica) {
            tags.push(
              <Tooltip key={`historico-${record._id}`} title="Factura cargada como histórico en la implementación (sin contabilidad)">
                <Tag color='default' className="square-tag2">Histórico</Tag>
              </Tooltip>
            )
          }

          const tipo = record.tipoFactura;
              
          // Mapeo de colores por tipo de factura
          const coloresTipo = {
            "Caja Chica": "magenta",
            "Con Orden De Compra": "purple",
            "Sin Orden De Compra": "cyan"
          };

          const colorFinal = coloresTipo[tipo] || 'default';

          tags.push(
            <Tag 
              key={`tipo-${record._id}`} 
              color={colorFinal} 
              className="square-tag2"
            >
              {tipo}
            </Tag>
          );
          
            return (
            <div style={{ display: 'flex', flexDirection: 'column', gap:'4px'  }}>
              {tags}
            </div>
          )     
        },
        width: '15%',
      }, 
      ...(this.props.mostrarComplementoPagoFacturas ? [{
        title: 'Complemento',
        dataIndex: 'tieneComplementoPago',
        key: 'tieneComplementoPago',
        align: 'center',
        width: '8%',
        render: (value) => value
          ? <Tag color="green" className="square-tag3">Con Rep</Tag>
          : <Tag color="gold" className="square-tag3">Sin Rep</Tag>,
      }] : []),
      {
         title: 'Acción',
        dataIndex: 'accion',
        key: 'accion',
        align: "center",
        width: '10%',
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, record, index) => {
           let buttons = []
          buttons.push(
          <Tooltip title="Mandar correo" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
            <ButtonItem
              key={`correo-${index}`}
              type="default"
              size="small"
              azul
              icon={<MailOutlined />}
              onClick={() => this.abrirMandarCorreoFactura(value._id, record.tipoFactura)}
            />
          </Tooltip>)

          // estadoOriginal y no estado: el backend pisa el estado con 3 en las facturas con
          // orden de compra, asi que una cancelada llegaria aqui como recibida.
          const puedeEditar =
            record.estadoOriginal !== 0 &&
            this.props[PERMISO_EDITAR_POR_TIPO[record.tipoFactura]];
          if (puedeEditar) {
            buttons.push(
              <Tooltip title="Editar datos" key={`editar-${index}`} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="default"
                  size="small"
                  naranja
                  icon={<EditOutlined />}
                  onClick={() => this.abrirEditarDatosFactura(value._id)}
                />
              </Tooltip>
            );
          }

          return buttons;
        }
      }
    ]
    return (
      <>
        <PageHeader
          title="Facturas"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 &&
                <SegmentedItem
                  options={[{ label: 'Vigente', value: 1 }, { label: 'Cancelada', value: 2 }, { label: 'Todos', value: 3 }]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({ valor: value });
                    }
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              }
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={totalRecords}
          loading={loading}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarFacturas.bind(this)}
          size="small"
          dataSource={todasFacturas}
          columns={columns}
          pagination={false}
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })} 
          filterStorageKey={"facturasGeneralesFiltros" + this.props.empresaId}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
          
          onRow={(record) => {
            return {
              onDoubleClick: () => {
                const ruta = record.tipoFactura === 'Caja Chica' ? '/panel/verFacturaCajaChica' : record.tipoFactura === 'Sin Orden De Compra' ? '/panel/verFacturaSinOrdenDeCompra' : '/panel/verFacturaOrdenDeCompra';
                this.props.history.push(ruta, { id: record._id })
              },
            };
          }}
          locale={{ emptyText: "No se encontraron facturas" }}
        />
       <ModalMandarCorreoFacturas
          visible={this.state.modalCorreo}
          id={this.state.modalCorreoId}
          cerrarModalMandarCorreoFacturas={this.cerrarMandarCorreoFactura.bind(
            this,
          )}
          tipoFactura ={this.state.tipoFactura}
        />
        <ModalEditarDatosFactura
          visible={this.state.modalEditarDatos}
          facturaId={this.state.modalEditarDatosId}
          onCancel={() => this.cerrarEditarDatosFactura(false)}
          onSuccess={() => this.cerrarEditarDatosFactura(true)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    mostrarComplementoPagoFacturas: state.empresa.mostrarComplementoPagoFacturas,
    permisoEditarFacturasCajaChica: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a94a0961aa752bd8701458a")?.activado,
    permisoEditarFacturasSinOrdenDeCompra: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a94a0881aa752bd87014589")?.activado,
    permisoEditarFacturasOrdenDeCompra: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a94a06bd51a26d4c5731dcb")?.activado,
  };
};

export default connect(mapStateToProps)(Facturas);